<template>
  <q-page padding>
    <UserLogin></UserLogin>
  </q-page>
</template>

<script setup lang="ts">
import UserLogin from 'components/UserLogin.vue'
</script>
